import {
  type Dispatch,
  type ReactNode,
  type SetStateAction,
  useState,
} from "react";

import { Button } from "common/components/ui/Button";
import {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerDescription,
  DrawerFooter,
  DrawerTitle,
} from "common/components/ui/Drawer";
import type { SubscriptionType } from "common/types";

import SubscriptionCard from "./SubscriptionCard";
import SubscriptionTypeCards from "./SubscriptionTypeCards";

import LockedIcon from "assets/icons/locked.svg?react";

interface MobileLayoutProps {
  title: string;
  subscriptionType: SubscriptionType;
  startTrialButton: ReactNode;
  setSubscriptionType: Dispatch<SetStateAction<SubscriptionType>>;
  onContinue: () => void;
}

export default function MobileLayout({
  title,
  subscriptionType,
  startTrialButton,
  setSubscriptionType,
  onContinue,
}: MobileLayoutProps) {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  return (
    <>
      <div className="flex items-center justify-center flex-col grow p-4">
        <LockedIcon className="mb-7" />
        <h2 className="text-xl-bold mb-1.5">Page locked</h2>
        <p className="text-black-500 text-sm mb-4">
          {title}. Choose a plan to proceed
        </p>
        <Button onClick={() => setIsDrawerOpen(true)}>Continue</Button>
      </div>

      <Drawer open={isDrawerOpen} onOpenChange={setIsDrawerOpen}>
        <DrawerContent className="pb-20">
          <DrawerTitle>{title}</DrawerTitle>
          <DrawerDescription className="mb-4">
            Choose a plan to proceed:
          </DrawerDescription>

          <div className="flex flex-col gap-y-4">
            <SubscriptionTypeCards
              subscriptionType={subscriptionType}
              setSubscriptionType={setSubscriptionType}
            />

            <SubscriptionCard type={subscriptionType} />
          </div>

          <DrawerFooter>
            <DrawerClose asChild>
              <Button variant="secondary-black" size="lg">
                Cancel
              </Button>
            </DrawerClose>
            {startTrialButton || (
              <Button onClick={onContinue} size="lg">
                Continue
              </Button>
            )}
          </DrawerFooter>
        </DrawerContent>
      </Drawer>
    </>
  );
}
